const scope = "ratings";
export default scope;